export const skeletonColor = Styles.color.grey.ten;
